import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleEnquirySelected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      fill="none"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle opacity={0.88} cx={28} cy={28} r={28} fill="#56A" />
      <path
        d="M39.66 15H16.37a2.87 2.87 0 00-2.87 2.87v15.55a2.87 2.87 0 002.87 2.87h3.76c-.1 1.4-.16 2.26-.83 4.31-.37 1.16.92 2.14 1.93 1.47 3.54-2.36 5.4-4.07 6.77-5.78h11.63a2.87 2.87 0 002.87-2.87V17.87A2.82 2.82 0 0039.66 15zM34.6 31.1c0 .37-.27.68-.64.68h-1.4a.68.68 0 01-.68-.67v-1.2c0-.36.31-.67.68-.67h1.37c.37 0 .67.3.67.67v1.2zm.46-4.76c-.58.49-.58.52-.58.8v.24c0 .36-.3.67-.67.67h-1.13a.68.68 0 01-.67-.67v-.25c0-1.37.67-2.04 1.5-2.69.48-.4 1.37-1.13 1.37-1.7 0-.98-.55-1.2-1.4-1.2-1.53 0-1.56 1.04-1.56 1.16v.1c0 .36-.31.67-.68.67h-1.13a.68.68 0 01-.67-.68v-.09c0-1.4 1.1-3.63 4.03-3.63 2.88 0 3.88 1.9 3.88 3.66 0 1.78-1.5 2.97-2.29 3.6z"
        fill="#fff"
      />
      <path
        opacity={0.88}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.64 22.7c.2 0 .36-.2.36-.43v-.84c0-.24-.16-.43-.36-.43h-8.28c-.2 0-.36.2-.36.43v.84c0 .24.16.43.36.43h8.28zm.36 3.37c0 .24-.16.43-.36.43h-8.28c-.2 0-.36-.2-.36-.43v-.85c0-.23.16-.42.36-.42h8.28c.2 0 .36.2.36.42v.85zm-2 3.8c0 .24-.16.43-.35.43h-6.3c-.2 0-.35-.2-.35-.43v-.85c0-.23.16-.42.35-.42h6.3c.2 0 .35.2.35.42v.86z"
        fill="#8F9DD6"
      />
    </svg>
  );
}

SvgPicCircleEnquirySelected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleEnquirySelected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleEnquirySelected svgRef={ref} {...props} />
));
export default ForwardRef;
